module.exports = __webpack_public_path__ + "img/iphone_3.6c87100e.png";